import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { FaRegTimesCircle } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import clienteAxios from "../Utils/axios";

const DragDrop = ({
  Get_Archivos_F,
  archivos,
  MaximoArchivos,
  Errores,
  setErrores,
}) => {
  const onDrop = useCallback(
    async (acceptedFiles) => {
      const fileNames = archivos.reduce(
        (names, file) => ({ ...names, [file.name]: true }),
        {}
      );
      if (acceptedFiles.find((file) => fileNames[file.name])) {
        toast.info("El archivo ya fue agregado.");
        return;
      }

      if (acceptedFiles[0].size > 10000000) {
        toast.error("El peso maxímo es de 10 MB.");
        return;
      } else if (acceptedFiles[0].size === 0) {
        toast.error("El archivo es inválido.");
        return;
      }

      let tamanio = (acceptedFiles[0].size / 1048576).toFixed(2)
      if(tamanio === '0.00'){
        toast.error("El archivo está vacío.")
        return;

      }

      if (
        acceptedFiles[0].type !== "image/jpeg" &&
        acceptedFiles[0].type !== "image/png" &&
        acceptedFiles[0].type !== "application/pdf"
      ) {
        toast.error("El formato es incorrecto.");
        return;
      }

      if (acceptedFiles[0].type === "application/pdf") {
        try {
          const dataForm = new FormData();
          dataForm.append("file", acceptedFiles[0], acceptedFiles[0].name);

          const respuesta = await clienteAxios.post("ValidatePdf/", dataForm);
          if (respuesta.status === 203) {
            toast.error("No se permiten archivos encriptados.");
            return;
          } else if (respuesta.status === 204) {
            toast.error("No se permiten archivos corruptos.");
            return;
          }
        } catch (error) {
          toast.error("Error con la conexión al servidor, intente mas tarde.");
        }

        try {
          const dataForm = new FormData()
          dataForm.append("file", acceptedFiles[0], acceptedFiles[0].name)
    
          const respuesta = await clienteAxios.post("ValidatePdfEof/", dataForm)
    
          if(respuesta.status === 204){
            toast.error("No se permiten archivos dañados.");
            return;
          }
          
        } catch (error) {
          console.log(error)
          toast.error("El con la conexión al servidor, intente mas tarde.")
    
        }

      }

      if (acceptedFiles[0].type === "image/png" || acceptedFiles[0].type === "image/jpeg") {
        try {
          const dataForm = new FormData();
          dataForm.append("file", acceptedFiles[0], acceptedFiles[0].name);
          const respuesta = await clienteAxios.post("ValidaImgCorrup/", dataForm);
          if (respuesta.status === 204) {
            toast.error("No se permiten archivos corruptos.");
            return;
          }
        } catch (error) {
          toast.error("Error con la conexión al servidor, intente mas tarde.");
        }
      }

      setErrores({
        ...Errores,
        archivo: false,
      });

      const FindPdf = archivos.find((file) => file.mime === "application/pdf");
      const FindImg = archivos.find(
        (file) =>
          file.mime === "image/png" ||
          file.mime === "image/jpeg" ||
          file.mime === "image/jpg"
      );
      if (
        FindImg !== undefined &&
        FindImg !== "undefined" &&
        FindImg !== null
      ) {
        if (acceptedFiles[0].type === "application/pdf") {
          toast.error(`Sólo permite imagenes.`);
          return;
        }
      }

      if (
        FindPdf !== undefined &&
        FindPdf !== "undefined" &&
        FindPdf !== null
      ) {
        toast.error(`Sólo permite 1 archivo pdf.`);
        return;
      }

      const allFiles = [
        ...archivos,
        ...acceptedFiles.map((acceptedFile) => ({
          file: acceptedFile,
          objectURL: URL.createObjectURL(acceptedFile),
          mime: acceptedFile.type,
          size: acceptedFile.size,
          name: acceptedFile.name,
        })),
      ];

      let size = 0;
      let extension = "";

      for (var i = 0; i < allFiles.length; i++){

        if(extension === "image/jpeg" || extension === "image/png" || extension === "image/jpg"){
          if(allFiles[i].mime === 'application/pdf'){
            
            toast.error(`Solo permite imágenes o pdf.`);
            return;
          }
    
          const dataForm = new FormData();
          dataForm.append("file", allFiles[i].file, allFiles[i].name);
          const respuesta = await clienteAxios.post("ValidaImgCorrup/", dataForm);
          if (respuesta.status === 204) {
            toast.error("No se permiten archivos corruptos.");
            return;
          }
    
        }else if(extension === "application/pdf" ){
          if(allFiles[i].mime === "image/jpeg" || allFiles[i].mime === "image/png" || allFiles[i].mime === "image/jpg"){
    
            toast.error(`Solo permite imágenes o pdf.`);
            return;
          }else if(allFiles[i].mime === "application/pdf"){
            
              toast.error(`Sólo permite 1 archivo pdf.`);
            return;
          }
    
          try {
            const dataForm = new FormData()
            dataForm.append("file", allFiles[i].file, allFiles[i].name)
      
            const respuesta = await clienteAxios.post("ValidatePdf/", dataForm)
      
            if(respuesta.status === 203){
              toast.error("No se permiten archivos encriptados.");
              return;
            }else if(respuesta.status === 204){
              toast.error("No se permiten archivos corruptos.");
              return;
            }
            
          } catch (error) {
            console.log(error)
            toast.error("El con la conexión al servidor, intente mas tarde.")
      
          }
    
          try {
            const dataForm = new FormData()
            dataForm.append("file", allFiles[i].file, allFiles[i].name)
      
            const respuesta = await clienteAxios.post("ValidatePdfEof/", dataForm)
      
            if(respuesta.status === 204){
              toast.error("No se permiten archivos dañados.");
              return;
            }
            
          } catch (error) {
            console.log(error)
            toast.error("El con la conexión al servidor, intente mas tarde.")
      
          }
    
        }
    
        extension = allFiles[i].mime
        size += allFiles[i].size
      }

      if(size > 10000000){
        toast.error(`El peso máximo es de 10 mb.`);
      }

      if (archivos.length < MaximoArchivos) {
        Get_Archivos_F(allFiles);
      } else {
        toast.error(`Sólo permite hasta ${MaximoArchivos} archivos.`);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [archivos]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleDelete = (file) => {
    const Deleted = archivos.filter((archivo) => archivo.name !== file);
    Get_Archivos_F(Deleted);
  };

  const files = archivos.map((file, i) => (
    <p className="bg-dropzone py-auto d-flex" key={i}>
      {`${file.name} - ${(file.size / 1048576).toFixed(2)} MB`}

      <FaRegTimesCircle
        onClick={() => handleDelete(file.name)}
        className="my-auto py-auto ml-auto pointer"
      />
    </p>
  ));

  return (
    <>
      <ToastContainer closeOnClick={true} pauseOnHover={true} />
      <section
        className={`container my-2 misuper-dropzone ${
          Errores.archivo && "error"
        }`}
      >
        <div {...getRootProps({ className: "misuper-dropzone-btn" })}>
          <input {...getInputProps()} />
          <p className="my-0">Arrastre el archivo de la comunicación o haga click.</p>
          <small className="d-block my-0 text-dark">
            - Comunicación de adecuación enviada por la Isapre (Todas sus hojas), solo
            permite un archivo PDF o imágenes.
          </small>
          <small className="d-block my-0 text-dark">
            - Peso máximo total de los adjuntos es de 10 mb.
          </small>
        </div>
        <aside className="center mx-auto ">
          <div>{files}</div>
        </aside>
      </section>
    </>
  );
};

export default DragDrop;
